<template>
<div>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Password">
          <b-form-checkbox
            @change="passwordChange"
            v-model="activeField.showPassword"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Disabled">
          <b-form-checkbox
            v-model="activeField.disabled"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="6">
      <b-form-group label="Prepend">
        <b-form-input v-model="activeField.prepend"></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Append">
        <b-form-input v-model="activeField.append"></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="6">
      <b-form-group label="Minimum length">
        <b-form-input v-model="activeField.minlength"></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Maximum length">
        <b-form-input v-model="activeField.maxlength"></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>

  <b-form-group label="Regex Validation">
    <b-row>
      <b-col cols="3">
        <b-form-checkbox v-model="activeField.hasRegexValidation" class="mt-2" switch></b-form-checkbox>
      </b-col>
      <b-col cols="9">
        <b-form-input
        :disabled="!activeField.hasRegexValidation"
        v-model="activeField.regex">{{activeField.regex}}</b-form-input>
      </b-col>
    </b-row>
  </b-form-group>

</div>
</template>
<script>
export default {
  name: 'TextInputAdvancedProps',
  store: ['activeField'],
  data() {
    return {
      name: ''
    }
  },
  methods: {
    passwordChange(value) {
      if (value) {
        this.activeField.showWordLimit = false;
      }
    },
    showWordLimitChange(value) {
      if (value) {
        this.activeField.showPassword = false;
      }
    }
  }
}
</script>
